import { useState } from 'react';
import { api, useAction } from '../../../api/hooks';
import { Button } from '../../../ui/Button';
import { Alert, ErrorAlert } from '../../../ui/feedback';
import { Modal } from '../../../ui/Modal';
import { CandidateForm, fromBinding, toPayload } from '../CandidateForm';
import type { ReleaseDetail } from '../types';

export function EditCandidate({
  r,
  onClose,
  inv,
}: {
  r: ReleaseDetail;
  onClose: () => void;
  inv: unknown[][];
}) {
  const [v, setV] = useState(fromBinding(r.candidate!.binding));
  const save = useAction(
    () =>
      api.put(`/projects/${r.project.key}/releases/${r.displayId}`, {
        ...toPayload(v),
        expectedVersion: r.version,
      }),
    { success: 'New candidate saved', invalidate: inv as never, onSuccess: onClose },
  );
  return (
    <Modal
      title={r.state === 'failed' ? `Prepare retry for ${r.displayId}` : `Edit ${r.displayId}`}
      onClose={onClose}
      wide
      actions={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={() => save.mutate(undefined)} loading={save.isPending}>
            Save candidate {(r.candidate?.number ?? 0) + 1}
          </Button>
        </>
      }
    >
      <Alert tone="info">
        Saving creates a new candidate and returns the release to draft. Outstanding approvals become stale;
        previous candidates and attempts are preserved.
      </Alert>
      <CandidateForm
        projectKey={r.project.key}
        value={v}
        onChange={setV}
        currentTickets={r.tickets.filter((t) => t.reserved).map((t) => t.key)}
      />
      <ErrorAlert error={save.error} />
    </Modal>
  );
}
